import { ShareIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import React from 'react';

interface ShareButtonProps {
  propertyId: string;
}

const ShareButton: React.FC<React.PropsWithChildren<ShareButtonProps>> = ({ propertyId }) => {
  const onClick = () => {
    if (typeof navigator?.share !== 'undefined') {
      navigator.share({
        title: document.title,
        url: `https://koolumbus.com/property/${propertyId}`,
      });
    }
  };

  return (
    <button
      onClick={onClick}
      aria-label="share"
      type="button"
      className={clsx(
        'w-10 h-10 inline-flex justify-center items-center border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white',
        'hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary',
      )}
    >
      <ShareIcon className="w-5 h-5 text-gray-500" aria-hidden={true} />
    </button>
  );
};

export default ShareButton;
